import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
/* import RelatedWorks from "./RelatedWorks"; */
import CustomVideoPlayer from "./CustomVideoPlayer";
import "./WorkDetail.css";

export default function SmileauraDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
       Smile Aura Dental Studio
        </h1>

        <p className="project-description">
We built a cohesive brand identity and digital presence for Smileaura through branding, logo design, video production, motion graphics, social media, and website design, creating a modern and trusted brand experience that reflects the clinic's commitment to quality dental care.
        </p>

        <div className="project-tags">
          <span className="info-tag">Brand Identity</span>
          <span className="info-tag">Logo Design</span>
          <span className="info-tag">Website Design</span>
          <span className="info-tag">Video Production</span>
          <span className="info-tag">Video Editing</span>
          <span className="info-tag">Motion Graphics</span>
          <span className="info-tag">Social Media Design</span>
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Smileaura/Full1.webp" alt="Feston Hero Sketch" />
      </div>


      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Smileaura/Full2.webp" alt="Feston Hero Sketch" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We developed a refined logo and visual identity system for Smileaura, capturing the clinic's commitment to premium dental care and patient confidence. The design balances elegance and simplicity, helping build a recognizable and trustworthy brand experience across every customer touchpoint"
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Smileaura/Full3.webp" alt="Feston Hero Sketch" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created a responsive and visually refined website for Smileaura, translating the clinic's brand identity into a compelling digital experience. With a focus on usability, accessibility, and patient convenience, the website effectively showcases treatments, expertise, and clinic facilities while strengthening Smileaura's online presence."
        </div>
      </section>


      {/* Three portrait videos in a row */}
      <section className="project-three-videos-section">
        <CustomVideoPlayer
          src="https://ascentbw.com/Images/Smileaura/Vid1.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <CustomVideoPlayer
          src="https://ascentbw.com/Images/Smileaura/Vid2.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <CustomVideoPlayer
          src="https://ascentbw.com/Images/Smileaura/Vid3.webm"
          autoPlay
          loop
          muted
          playsInline
        />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created high-quality video campaigns for Smileaura, integrating cinematic video production, dynamic editing, and custom motion graphics. The content highlights the clinic's expertise, advanced treatments, and welcoming atmosphere, helping strengthen patient confidence while delivering a polished and professional brand experience across digital platforms."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Smileaura/Full4.webp" alt="Feston Hero Sketch" />
      </div>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Smileaura/Full5.webp" alt="Feston Hero Sketch" />
      </div>
      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created impactful social media campaigns and promotional creatives for Smileaura, enhancing brand awareness, patient engagement, and digital visibility through strategic content and consistent visual communication."
        </div>
      </section>

      {/* <RelatedWorks excludePath="/works/smileaura" /> */}
      <Footer />
    </div>
  );
}
